import { Box, HeartHandshake, Megaphone, Briefcase, Library } from 'lucide-react';
import type { PaneType } from './contexts/PaneContext';

export const PANE_ICONS: Record<PaneType, React.ReactNode> = {
  product: <Box size={18} />,
  success: <HeartHandshake size={18} />,
  sales: <Megaphone size={18} />,
  ops: <Briefcase size={18} />,
  archie: (
    <img
      src="/archie-avatar.png"
      alt="Archie"
      width={20}
      height={20}
      className="rounded-full ring-1 ring-slate-200/60 shadow-sm"
      style={{ imageRendering: 'auto', display: 'block' }}
    />
  ),
  documentation: <Library size={18} />,
};
